import { questionnaireGql } from '../../../data/gql-gen/questionnaire'

export const LOOPING_DATA = questionnaireGql(/* GraphQL */ `
  query loopingData($projectId: ID!, $surveyId: ID, $waveId: ID) {
    draftQuestionnaire: draftQuestionnaireV2(
      projectId: $projectId
      surveyId: $surveyId
      waveId: $waveId
    ) {
      # Normalised by questionnaireId, so it has to be selected here too, not just on the entry items.
      questionnaireId
      entries {
        number
        contextPosition
        entryType
        entryItem {
          ... on DraftSectionItem {
            sectionId
            entries {
              number
              contextPosition
              entryType
            }
            settingValues {
              code
              value
            }
            isLoopingEnabled @client
            loopingConfig {
              sourceEntryNumber
            }
          }
          # Only sections are read here, but every entry type comes back, and the cache normalises
          # these three by a key field — a branch carrying only __typename fails keyFields extraction
          # on write ("Missing field 'questionLk'"). The other members are not normalised.
          ... on DraftQuestionItem {
            questionLk
          }
          ... on DraftMatrixItem {
            matrixTitleLk
          }
          ... on DraftTextCardItem {
            textCardLk
          }
        }
      }
    }
  }
`)
